import { showNotification } from "../../components/UI/Toaster/Toaster";
import { convertMsgResponse } from "../../containers/Reservation/fox-reservation/fox-res-helper";
import { invokeServerAPI } from "../../services/httpService";
import { RequestHandleType } from "../utility/enum-utility";

const onRetrieveResponse = (
  response,
  requestHandleType = RequestHandleType.MSG_ONLY,
  showError = false
) => {
  if (response?.message) {
    if (requestHandleType === RequestHandleType.MSG_ONLY) {
      showResponseMsg(response.message);
      return true;
    } else if (requestHandleType === RequestHandleType.RESPONSE_ONLY) {
      if (showError) showResponseMsg(response.message);
      return response;
    } else if (requestHandleType === RequestHandleType.MSG_WITH_RESPONSE) {
      showResponseMsg(response.message);
      return response;
    } else {
      showResponseMsg(response.message);
      return false;
    }
  }
};

export const doExtendRentalFunctionality = async (
  request,
  requestHandleType = RequestHandleType.MSG_ONLY,
  showError = false
) => {
  if (!request) return false;
  const response = await invokeServerAPI(
    "foxapi/rentalextension",
    request,
    true
  );
  return onRetrieveResponse(
    response,
    requestHandleType,
    showError && response?.message && response?.message?.messageType === "ERROR"
  );
};
export const showResponseMsg = (toastMsg) => {
  showNotification(convertMsgResponse(toastMsg));
};
